import { useState, useContext } from 'react'
import { Paper, IconButton, Typography, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Close as CloseIcon } from '@material-ui/icons'
import Link from 'next/link'
import QuantitySelector from '../../components/QuantitySelector'
import { Hbox } from '../../components/layout/Box'
import Image from '../../lib/react-storefront/Image'
import SessionContext from '../../contexts/SessionContext'
import RemoveDialog from './RemoveDialog'
const styles = theme => ({
  root: {
    flex: 1,
    padding: theme.spacing(2, 5, 2, 2),
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  thumb: {
    marginRight: theme.spacing(2),
    width: 200,
    [theme.breakpoints.down('xs')]: {
      width: 100,
    },
  },
  label: {
    marginRight: theme.spacing(0.6),
  },
  remove: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  itemTitle: {
    color: '#000',
  },
})
const useStyles = makeStyles(styles)

export default function CartItem({ product, updateQuantity, remove }) {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const { config } = useContext(SessionContext)
  return (
    <>
      <Paper className={classes.root} elevation={3}>
        <Hbox alignItems="flex-start">
          <Grid container spacing={2} direction="row">
            <Grid className="highlight-txt" item xs={12} sm={6} md={6}>
              <Grid container spacing={2} direction="row">
                <Grid className="highlight-txt" item xs={12} lg={5} md={5} sm={5}>
                  <Image src={product.thumbnail.src} fill aspectRatio={1} quality={50} />
                </Grid>
                <Grid className="highlight-txt" item xs={12} lg={7} md={7} sm={7}>
                  <Link
                    as={product.url}
                    href="/store/[storeSlug]/p/[productId]"
                    pageData={{ product }}
                  >
                    <Typography color="primary" variant="subtitle1" className={classes.itemTitle}>
                        {product.name}
                      </Typography>
                  </Link>
                  <Typography className={(classes.price, 'font-sm')}>
                    {product.priceText}
                  </Typography>
                  {product.size && (
                    <Hbox>
                      <Typography className={(classes.label, 'font-sm')}>Size:</Typography>
                      <Typography>{product.size}</Typography>
                    </Hbox>
                  )}
                  {product.mod && product.mods.length > 1 && (
                    <Hbox>
                      <Typography className={classes.label}>Modifier:</Typography>
                      <Typography>{product.mod.text}</Typography>
                    </Hbox>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid className="highlight-txt" item xs={12} lg={3} md={3} sm={3}>
              <span className="mobile-show">QTY: &nbsp; </span>
              <span className="checkout-QTY">
                <QuantitySelector
                  maxValue={
                    config.outofstock == 'ignoreinventorylevel' ? 999999 : product.stocklevel
                  }
                  value={product.quantity}
                  onChange={quantity =>
                    updateQuantity(product, product.mod, product.size, quantity)
                  }
                />
              </span>
            </Grid>
            <Grid className="highlight-txt pad-l18" item xs={12} lg={3} md={3} sm={3}>
              <Typography className="font-sm">
                <span className="mobile-show">Item Total:</span>{' '}
                <b>${parseFloat(product.price * product.quantity).toFixed(2)}</b>
              </Typography>
            </Grid>
          </Grid>
        </Hbox>
        <IconButton className={classes.remove} onClick={() => setOpen(true)}>
          <CloseIcon />
        </IconButton>
      </Paper>
      <RemoveDialog
        open={open}
        setOpen={setOpen}
        name={product.name}
        action={() => remove(product)}
      />
    </>
  )
}
